export default __webpack_public_path__ + "static/media/Imperial-Fleet-05.0737c4c0.jpg";